export const MONTHS = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember",
];

export const WEEKDAYS = [
  "Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag",
];

export function parseDate(iso) {
  const p = String(iso || "").split("-").map(Number);
  return p.length === 3 && p[0] ? new Date(p[0], p[1] - 1, p[2]) : null;
}

const today = () => {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
};

export function isUpcoming(iso) {
  const d = parseDate(iso);
  return !!d && d >= today();
}

export function daysUntil(iso) {
  const d = parseDate(iso);
  return d ? Math.round((d - today()) / 86400000) : null;
}

export function countdownLabel(iso) {
  const n = daysUntil(iso);
  if (n === null) return "";
  if (n === 0) return "heute";
  if (n === 1) return "morgen";
  if (n < 14) return `in ${n} Tagen`;
  return `in ${Math.round(n / 7)} Wochen`;
}

export const dayNum = (iso) => (parseDate(iso) ? String(parseDate(iso).getDate()) : "–");
export const monShort = (iso) => (parseDate(iso) ? MONTHS[parseDate(iso).getMonth()].slice(0, 3) : "");
export const monLong = (iso) => (parseDate(iso) ? MONTHS[parseDate(iso).getMonth()] : "");
export const yearOf = (iso) => (parseDate(iso) ? parseDate(iso).getFullYear() : "");
export const weekday = (iso) => (parseDate(iso) ? WEEKDAYS[parseDate(iso).getDay()] : "");

/** "Donnerstag, 26. September 2026, 18:30–21:00 Uhr" */
export function whenLine(ev) {
  const d = parseDate(ev.date);
  if (!d) return "";
  let s = `${WEEKDAYS[d.getDay()]}, ${d.getDate()}. ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  if (ev.timeFrom) s += `, ${ev.timeFrom}`;
  if (ev.timeTo) s += `–${ev.timeTo} Uhr`;
  else if (ev.timeFrom) s += " Uhr";
  return s;
}

/** Kurzdatum für Listen in der Verwaltung. */
export function shortDate(iso) {
  const d = parseDate(iso);
  return d ? `${d.getDate()}. ${MONTHS[d.getMonth()].slice(0, 3)} ${d.getFullYear()}` : "ohne Datum";
}

export function monogram(name) {
  const p = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!p.length) return "?";
  return (p.length === 1 ? p[0].slice(0, 2) : p[0][0] + p[1][0]).toUpperCase();
}

export const tidyUrl = (u) => (!u ? "" : /^https?:\/\//i.test(u) ? u : `https://${u}`);

export const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim());

export const sortEvents = {
  upcoming: (a, b) => a.date.localeCompare(b.date),
  past: (a, b) => b.date.localeCompare(a.date),
};
